module.exports = __webpack_public_path__ + "static/media/CLEVER.35fac177.svg";